import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./auth/microsoftConfig";

const msalInstance = new PublicClientApplication(msalConfig);

async function startApp() {
  await msalInstance.initialize();
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <MsalProvider instance={msalInstance}>
      <GoogleOAuthProvider clientId="1007523990663-klmto9dqur1v2huugk2pfp97s2r4iqtr.apps.googleusercontent.com">
        {/* exambridge */}
        <App />
      </GoogleOAuthProvider>
    </MsalProvider>,
  );
}

startApp();

/*
Google:
Project number:  1007523990663
Project ID:  exams-490117

Web Client1 (localhost):
ID:  1007523990663-k1p1sjfbb1kgk4qqd9lfg8gcfhbodl1j.apps.googleusercontent.com
Client secret:  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

Web Client 2 (exambridge.com):
id:  1007523990663-klmto9dqur1v2huugk2pfp97s2r4iqtr.apps.googleusercontent.com
Client secret:  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

Web Client 3 (bits.exambridge.com):
id:  1007523990663-ikouivbtnkobd3ingln59v8vfsnmns38.apps.googleusercontent.com
Client secret:  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
*/

